import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static classes = ["active"]

  select(event) {
    this.itemTargets.forEach((item) => {
      item.classList.remove(...this.activeClasses)
    })
    event.currentTarget.classList.add(...this.activeClasses)
  }
}
